var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('style',{tag:"component",attrs:{"type":"text/css"}},[_vm._v(" :root { "+_vm._s(_vm.variables)+" } ")])}
var staticRenderFns = []

export { render, staticRenderFns }